import api from './api'

export const productsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/products', { params })
    return res.data
  },

  getBySlug: async (slug) => {
    const res = await api.get(`/products/${slug}`)
    return res.data.data
  },

  getById: async (id) => {
    const res = await api.get(`/products/admin/${id}`)
    return res.data.data
  },

  toggleFeature: async (id) => {
    const res = await api.patch(`/products/${id}/feature`)
    return res.data.data
  },

  delete: async (id) => {
    await api.delete(`/products/${id}`)
  },

  // Admin-only: create product for any vendor
  adminCreate: async (data) => {
    const res = await api.post('/products/admin', data)
    return res.data.data
  },

  // Admin-only: update any product
  adminUpdate: async (id, data) => {
    const res = await api.patch(`/products/admin/${id}`, data)
    return res.data.data
  },

  addVariant: async (productId, data) => {
    const res = await api.post(`/products/${productId}/variants`, data)
    return res.data.data
  },

  updateVariant: async (productId, variantId, data) => {
    const res = await api.patch(`/products/${productId}/variants/${variantId}`, data)
    return res.data.data
  },

  deleteVariant: async (productId, variantId) => {
    await api.delete(`/products/${productId}/variants/${variantId}`)
  },

  downloadImportTemplate: async () => {
    const res = await api.get('/products/admin/import/template', { responseType: 'blob' })
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'products_import_template.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  },

  createImportJob: async (file, { vendorId, defaultCategoryId, downloadImages } = {}) => {
    const formData = new FormData()
    formData.append('file', file)
    if (vendorId) formData.append('vendorId', vendorId)
    if (defaultCategoryId) formData.append('defaultCategoryId', defaultCategoryId)
    formData.append('downloadImages', downloadImages ? 'true' : 'false')
    const res = await api.post('/products/admin/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return res.data.data
  },

  getImportJobs: async (params = {}) => {
    const res = await api.get('/products/admin/import/jobs', { params })
    return res.data
  },

  getImportJob: async (id) => {
    const res = await api.get(`/products/admin/import/jobs/${id}`)
    return res.data.data
  },
}
